import React, { createContext, useContext, useState } from 'react';

interface BusinessMetricsContextType {
  isDialogOpen: boolean;
  setIsDialogOpen: (open: boolean) => void;
  editingMetric: any;
  setEditingMetric: (metric: any) => void;
  selectedBrandId: string | null;
  setSelectedBrandId: (brandId: string | null) => void;
}

const BusinessMetricsContext = createContext<BusinessMetricsContextType | undefined>(undefined);

export const BusinessMetricsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [editingMetric, setEditingMetric] = useState<any>(null);
  const [selectedBrandId, setSelectedBrandId] = useState<string | null>(null);

  return (
    <BusinessMetricsContext.Provider value={{ 
      isDialogOpen, 
      setIsDialogOpen, 
      editingMetric, 
      setEditingMetric,
      selectedBrandId,
      setSelectedBrandId
    }}>
      {children}
    </BusinessMetricsContext.Provider>
  );
};

export const useBusinessMetricsDialog = () => {
  const context = useContext(BusinessMetricsContext);
  if (context === undefined) {
    throw new Error('useBusinessMetricsDialog must be used within a BusinessMetricsProvider');
  }
  return context;
};